import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import CaptchaCanvas from '../../components/CaptchaCanvas';

function RequireLink ({ label, action, loading, onSent, useCaptcha, ...rest }) {
  const { t } = useTranslation('authentication');
  const [matching, setMatching] = useState(!useCaptcha);

  return (
    <Form
      name="normal_login"
      layout={'vertical'}
      className="login-form"
      onFinish={onSent}
    >
      <Form.Item
        name="identifier"
        label={label}
        rules={[{ required: true }, { type: 'email' }]}
      >
        <Input type={'email'} disabled={loading} placeholder={t('email')} size={'large'} he/>
      </Form.Item>

      {useCaptcha && <Form.Item name="captcha" required>
        <CaptchaCanvas t={t} handleMatching={setMatching} {...rest}/>
      </Form.Item>}

      <Button
        loading={loading}
        disabled={loading || !matching}
        className={'w-full mt-4'}
        size={'large'}
        htmlType={'submit'}
        type={'primary'}
      >
        {action || t('recovery.send')}
      </Button>
    </Form>
  );
}

export default RequireLink;

RequireLink.propTypes = {
  action: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  useCaptcha: PropTypes.bool,
  onSent: PropTypes.func
};
